import { cacheDom } from "../utils/QuerySelectors.js"
import { validateEmail } from "../utils/helpers.js"

const dom = {}
const qs = {
  newsletterForm: 'data-newsletter-form',
  emailField: 'name="contact[email]"',
  emailError: 'data-email-error',
  submit: 'name="commit"',
}
const qsAll = {
  
}

const validateForm = (e) => {
  if(!validateEmail(dom.emailField.value)) {
    e.preventDefault()
    e.stopPropagation()
    dom.emailError.classList.remove('hidden')
  }
}

export const setupFooter = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.newsletterForm) {
    dom.emailField.addEventListener('keydown', (e) => {
      if(e.code && e.code.toUpperCase() == 'ENTER') validateForm(e)
    })
    dom.submit.addEventListener('click', (e) => {
      validateForm(e)
    })
    dom.emailField.addEventListener('input', () => {
      dom.emailError.classList.add('hidden')
    })
  }
}